"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideToolboxItem = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Icon_1 = require("../Common/Icon");
var Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
var ItemContainer = styled_components_1.default.div.attrs({
    className: 'tws-side-toolbox-item',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcursor: pointer;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmin-width: 50px;\n\twidth: 50px;\n\tmin-height: 50px;\n\theight: 50px;\n\ti {\n\t\tfont-size: 30px;\n\t}\n}\n"], ["\n\tcursor: pointer;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmin-width: 50px;\n\twidth: 50px;\n\tmin-height: 50px;\n\theight: 50px;\n\ti {\n\t\tfont-size: 30px;\n\t}\n}\n"])));
ItemContainer.displayName = 'ItemContainer';
var SideToolboxItem = function (props) {
    return (react_1.default.createElement(ItemContainer, { onClick: props.onClick }, props.tooltip ? (react_1.default.createElement(Tooltip_1.default, { id: props.icon, placement: 'right', iconName: props.icon, theme: { theme: 'compact' }, leaveIconStyle: true }, props.tooltip)) : (react_1.default.createElement(Icon_1.Icon, { name: props.icon }))));
};
exports.SideToolboxItem = SideToolboxItem;
var templateObject_1;
